import { RateChartPublic, RatesService } from "../client"

/* Interfaces & Types */
export type DocPreviewProps = {
    rate: RateChartPublic
}


/* ENDPOINTS */
export const getRatecharts = () => {
    return {
        queryFn: async () => {
        const data = await RatesService.readRates()
            return data ?? { data: null, count: 0 }
        },
        queryKey: ["settings-ratecharts"],
    }
}